import {
	LAST_PATCH_MENUS_GET,
	LAST_PATCH_MENUS_SUCCESS,
	LAST_PATCH_MENUS_BY_CHILD_GET,
	LAST_PATCH_MENUS_BY_CHILD_SUCCESS,
	PATCH_MENU_CONTENT_GET,
	PATCH_MENU_CONTENT_SUCCESS,
} from '../constants/patchMenu';

// Slice dédiée plutôt qu'un champ ajouté à patchMenu.reducer : celui-ci a un
// état de type tableau qu'il recrée à chaque action, une propriété rapportée
// y serait perdue au premier NEW_CLIENT.
//
// `patches` porte l'historique des déploiements du compte courant (vue child
// ou standalone), chargé page par page et accumulé ici — `hasMore` dit s'il
// reste quelque chose derrière. `children` porte le dernier déploiement de
// chaque établissement
// (vue agrégée du master). Les deux vues ne s'affichent jamais ensemble mais
// gardent des indicateurs de chargement distincts, leurs coûts n'ayant rien
// de comparable.
// `content` garde le contenu brut des patchs dépliés, indexé par patch (et
// par établissement dans la vue agrégée, deux bases pouvant porter le même
// id). Ce cache n'est jamais purgé à la fermeture d'un dépliage : replier
// puis rouvrir ne doit pas relancer de requête.
const initialState = {
	loading: false,
	// chargement d'une page suivante : distinct de `loading`, qui vide l'écran
	loadingMore: false,
	patches: [],
	hasMore: false,
	childrenLoading: false,
	children: [],
	content: {},
};

export default function lastPatchMenusReducer(state = initialState, action) {
	switch (action.type) {
		case LAST_PATCH_MENUS_GET:
			// Une page suivante s'ajoute à ce qui est affiché ; la première
			// remplace, et c'est elle seule qui montre le voile de chargement.
			return action.offset
				? { ...state, loadingMore: true }
				: { ...state, loading: true, patches: [] };
		case LAST_PATCH_MENUS_SUCCESS:
			return {
				...state,
				loading: false,
				loadingMore: false,
				hasMore: action.hasMore,
				patches: action.offset
					? [...state.patches, ...action.patches]
					: action.patches,
			};
		case LAST_PATCH_MENUS_BY_CHILD_GET:
			return { ...state, childrenLoading: true };
		case LAST_PATCH_MENUS_BY_CHILD_SUCCESS:
			return { ...state, childrenLoading: false, children: action.children };
		case PATCH_MENU_CONTENT_GET:
			return {
				...state,
				content: {
					...state.content,
					[action.key]: { loading: true, rows: [], total: 0, limit: 0 },
				},
			};
		case PATCH_MENU_CONTENT_SUCCESS:
			return {
				...state,
				content: {
					...state.content,
					[action.key]: {
						loading: false,
						rows: action.rows,
						total: action.total,
						limit: action.limit,
					},
				},
			};
		default:
			return state;
	}
}
